<template>
	<div class="transitionBox">
    <div class="transition" v-if="isLoding">
      <div class="transitionImg"><img src="../../../static/images/loading1.gif"></div>
      <div class="transitionHint">数据加载中...</div>
    </div>
    <div class="transition" v-else>
      <div class="transitionImg"><img src="../../../static/images/error.png"></div>
      <div class="transitionHint" v-text="msg"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transition',
  props: ['isLoding'],
  data () {
    return {
      msg:"内容为空！"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Transition.vue